import React from 'react';
import {
  Box,
  Typography,
  Grid
} from '@mui/material';
import InputDocUpload from '../../../../../utils/inputFileUpload/inputDocUpload';

interface Props {
  formData: {
    tipoRemetente: string;
    [key: string]: any;
  };
  anexos: {
    autorizacaoImportacao: File | null;
    certificadoImportacao: File | null;
    remetidoPorAnexoBi: File | null;
  };
  errors: Record<string, string>;
  handleFileChange: (name: string, file: File | null) => void;
  isUploading?: boolean;
}

const Step4Anexos: React.FC<Props> = ({ formData, anexos, errors, handleFileChange, isUploading }) => {
  const handleInputDocUploadChange = (file: File | null, name: string) => {
    handleFileChange(name, file);
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Anexar Documentos
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Por favor, anexe os documentos em formato PDF
      </Typography>

      <div style={{ display: 'flex', gap: '1rem' }}>
        <InputDocUpload
          onFileSelect={handleInputDocUploadChange}
          inputName="remetidoPorAnexoBi"
          inputTitle="Anexar BI do Responsável"
          inputDescription="Documento de identificação (BI) do responsável pela solicitação"
        />
        
        {formData.tipoRemetente === 'Importador' && (
          <>
            <InputDocUpload
              onFileSelect={handleInputDocUploadChange}
              inputName="autorizacaoImportacao"
              inputTitle="Autorização de Importação"
              inputDescription="Documento de autorização para importação dos produtos"
            />
            <InputDocUpload
              onFileSelect={handleInputDocUploadChange}
              inputName="certificadoImportacao"
              inputTitle="Certificado de Importação"
              inputDescription="Certificado oficial de importação dos produtos"
            />
          </>
        )}
      </div>
    </Box>
  );
};

export default Step4Anexos;
